<template>
  <div class="league-table-view">
    <div class="view-header">
      <h2>积分榜</h2>
      <!-- League Selector -->
      <div class="league-selector">
        <div
          v-for="country in countries"
          :key="country.id"
          class="flag-container"
          :class="{ active: selectedCountry && selectedCountry.id === country.id }"
          @click="selectCountry(country)"
        >
          {{ country.code }}
        </div>
      </div>
    </div>

    <div v-if="loading">Loading...</div>
    <div v-if="error">{{ error }}</div>

    <table v-if="standings.length" class="styled-table">
      <thead>
        <tr>
          <th>#</th>
          <th>球队</th>
          <th>场次</th>
          <th>胜</th>
          <th>平</th>
          <th>负</th>
          <th>进/失</th>
          <th>净胜球</th>
          <th>积分</th>
          <th>近期战绩</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="standing in standings" :key="standing.team">
          <td>{{ standing.position }}</td>
          <td>{{ standing.team_name }}</td>
          <td>{{ standing.played }}</td>
          <td>{{ standing.won }}</td>
          <td>{{ standing.drawn }}</td>
          <td>{{ standing.lost }}</td>
          <td>{{ standing.goals_for }}/{{ standing.goals_against }}</td>
          <td>{{ standing.goal_difference }}</td>
          <td>
            <strong>{{ standing.points }}</strong>
          </td>
          <td>{{ standing.recent_form }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="!loading && !error">
      <p>No standings available for this league.</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { fetchLeagueStandings, fetchCountries } from '@/api/client.js'

const standings = ref([])
const countries = ref([])
const selectedCountry = ref(null)
const loading = ref(true)
const error = ref(null)

const fetchStandings = async (countryId) => {
  loading.value = true
  error.value = null
  standings.value = []
  try {
    standings.value = await fetchLeagueStandings(countryId)
  } catch (e) {
    error.value = `Failed to fetch league standings for country ID ${countryId}: ${e.message}`
  } finally {
    loading.value = false
  }
}

const selectCountry = (country) => {
  selectedCountry.value = country
  fetchStandings(country.id)
}

onMounted(async () => {
  try {
    countries.value = await fetchCountries()
    if (countries.value.length > 0) {
      // Select the first country by default
      selectedCountry.value = countries.value[0]
      await fetchStandings(selectedCountry.value.id)
    }
  } catch (e) {
    error.value = `Failed to fetch countries: ${e.message}`
  }
})
</script>

<style scoped>
/* Styles remain the same */
.view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.league-selector {
  display: flex;
  gap: 10px;
}
.flag-container {
  cursor: pointer;
  padding: 5px;
  border: 2px solid transparent;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
}
.flag-container:hover {
  border-color: #3498db;
}
.flag-container.active {
  border-color: #2c3e50;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.flag-container img {
  width: 40px;
  height: auto;
  display: block;
}
.league-table-view {
  padding: 20px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 0.9em;
}
.styled-table thead tr {
  background-color: #2c3e50;
  color: #ffffff;
  text-align: left;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #2c3e50;
}
</style>
